import { AdminIcon } from "./icon";

interface PaginationProps {
	from: number;
	to: number;
	total: number;
	current: number;
	totalPages: number;
	onChange?: (page: number) => void;
}

export function Pagination({
	from,
	to,
	total,
	current,
	totalPages,
	onChange,
}: PaginationProps) {
	const go = (p: number) => {
		if (!onChange) return;
		const next = Math.min(Math.max(1, p), totalPages);
		if (next !== current) onChange(next);
	};
	// Construire la liste compacte des pages affichées.
	const pages: (number | "…")[] = [];
	const add = (p: number | "…") => {
		if (pages[pages.length - 1] !== p) pages.push(p);
	};
	add(1);
	for (let p = current - 1; p <= current + 1; p++) {
		if (p > 1 && p < totalPages) {
			if (p > 2 && pages[pages.length - 1] !== p - 1) add("…");
			add(p);
		}
	}
	if (totalPages > 1) {
		if (
			pages[pages.length - 1] !== totalPages - 1 &&
			pages[pages.length - 1] !== "…" &&
			totalPages > 2
		) {
			add("…");
		}
		add(totalPages);
	}
	return (
		<div className="pagi" style={{ padding: "12px 18px" }}>
			<div>
				Affichage {from} – {to} sur{" "}
				<strong className="tn">
					{total.toLocaleString("fr-FR").replace(/,/g, " ")}
				</strong>
			</div>
			<div className="pages">
				<button onClick={() => go(current - 1)} disabled={current <= 1}>
					<AdminIcon n="chevL" s={12} />
				</button>
				{pages.map((p, i) =>
					p === "…" ? (
						<button key={`e${i}`} disabled>
							…
						</button>
					) : (
						<button
							key={p}
							className={p === current ? "on" : ""}
							onClick={() => go(p)}
						>
							{p}
						</button>
					),
				)}
				<button
					onClick={() => go(current + 1)}
					disabled={current >= totalPages}
				>
					<AdminIcon n="chevR" s={12} />
				</button>
			</div>
		</div>
	);
}
